import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
// import React from 'react';
import { Stack, Box } from "@mui/material";
import { textFieldStyles } from "../styles/textFieldStyles";
import { CustomPaper } from "../styles/customPaper";
const FileAutocomplete = ({
  options,
  value,
  onChange,
  label,
  name,
  required,
  icon,
  sx,
  width,
}) => {
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => `${option.fileNo} - ${option.name}`}
      value={value}
      
      size="small"
      onChange={onChange}
      sx={textFieldStyles(width, "0", "0", "0")}
      PaperComponent={CustomPaper}
      renderOption={(props, option) => (
        <li {...props} style={{ padding: '0 12px' }}>
          <Box sx={{ width: '100%', pl: 1 }}>
            <Stack direction="column" spacing={0.5}>
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ fontSize: "0.7rem" }} // Smaller font size
              >
                {option.fileNo}
              </Typography>
              <Typography
                variant="caption"
                sx={{ fontWeight: "bold", fontSize: "0.8rem" }} // Smaller font size
              >
                {option.name}
              </Typography>
            </Stack>
          </Box>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          fullWidth
          required
          sx={sx}
          InputProps={{
            ...params.InputProps,
            startAdornment: icon ? (
              <InputAdornment position="start">{icon}</InputAdornment>
            ) : null,
          }}
        />
      )}
    />
  );
};

export default FileAutocomplete;
